import { fetchWrapper } from "../Helpers";

const baseUrl = `${process.env.REACT_APP_API_URL}/briefs`;

export const briefService = {
  getAll,
  createBrief,
  saveBrief,
  generateBrief,
};

function getAll(options) {
  let filterString = "";
  if (options && options.filter) {
    filterString = options.filter;
  }
  if (options && options.page !== undefined) {
    filterString = getAllPaging(options, filterString);
  }
  const url =
    filterString.length > 0 ? `${baseUrl}?${filterString}` : `${baseUrl}`;
  return fetchWrapper.get(url);
}

function getAllPaging(options, filterString) {
  filterString += filterString.length > 0 ? `&` : "";
  filterString += `page=${options.page}`;
  if (options.pageSize) {
    filterString += filterString.length > 0 ? `&` : "";
    filterString += `per_page=${options.pageSize}`;
  }
  return filterString;
}

/*function getById(id) {
  return fetchWrapper.get(`${baseUrl}/${id}`);
}*/

function createBrief(params) {
  return fetchWrapper.post(`${baseUrl}/generate`, params);
}

function generateBrief(params) {
  return fetchWrapper.post(`${baseUrl}/generateSummary`, params);
}

function saveBrief(params) {
  return fetchWrapper.post(`${baseUrl}`, params);
}

// prefixed with underscore because 'delete' is a reserved word in javascript
function _delete(id) {
  return fetchWrapper.delete(`${baseUrl}/${id}`);
}
